const formatLanguageLocale = (language = ''): string => {
  const langParts = language.split(/[_-]/);
  let locale = langParts[0].toLowerCase();
  if (langParts.length > 1) {
    locale += `_${langParts[1].toUpperCase()}`;
  }
  return locale;
};

export { formatLanguageLocale };
